module.exports = __webpack_public_path__ + "img/Subtract.1e72a5d7.svg";